import mongoose from "mongoose";
import { match } from "@mssi/pssp-shared";
import { TableQuery } from "../table";

export interface ExtendedSRSerialInfo {
  [key: string]: string;
}

export interface ServiceRequest {
  _id: mongoose.Schema.Types.ObjectId;
  itsmCustomerId: string;
  requestItemNumber: string;
  item: string;
  requestType: string;
  serialNumbers?: string[];
  extendedInfo?: Record<string, ExtendedSRSerialInfo>;
  requestedFor?: string;
  requestedForId?: string;
  requestedForEmail?: string;
  assignedTo?: string;
  createdAt?: string;
  state?: string;
  stage?: string;
  refreshId?: string;
}

export const ServiceRequestSchema = new mongoose.Schema<ServiceRequest>({
  itsmCustomerId: { type: String, index: true },
  requestItemNumber: { type: String, index: true, unique: true },
  item: { type: String, index: true },
  requestType: { type: String, index: true },
  serialNumbers: { type: [String], index: true },
  extendedInfo: { type: mongoose.Schema.Types.Mixed },
  requestedFor: { type: String, index: true },
  requestedForId: { type: String, index: true },
  requestedForEmail: { type: String, index: true },
  assignedTo: { type: String, index: true },
  createdAt: { type: String, index: true },
  state: { type: String, index: true },
  stage:  { type: String, index: true },
  refreshId: { type: String, index: true },
});

const paramProps = [
  "itsmCustomerId",
  "requestItemNumber",
  "serialNumbers",
  "item",
  "createdAt",
  "assignedTo",
  "requestedFor",
  "requestedForEmail",
  "requestedForId",
] as const;

const searchProps = [
  "requestItemNumber",
  "serialNumbers",
  "requestedFor",
  "requestedForEmail",
  "assignedTo",
  "createdAt",
  "stage",
] as const;

const filterProps = [
  "requestType",
  "state",
  "stage",
  "item"
] as const

const props = [
  "itsmCustomerId",
  "requestItemNumber",
  "item",
  "requestType",
  "serialNumbers",
  "requestedFor",
  "requestedForId",
  "requestedForEmail",
  "assignedTo",
  "createdAt",
  "state",
  "stage",
] as const;

export type ServiceRequestTableParams = Partial<Pick<ServiceRequest, typeof paramProps[number]>>
export type ServiceRequestTableSearch = Partial<Pick<ServiceRequest, typeof searchProps[number]>>;
export type ServiceRequestTableFilter = Partial<Pick<ServiceRequest, typeof filterProps[number]>>;

export type ServiceRequestTableQuery = TableQuery<ServiceRequestTableSearch & ServiceRequestTableFilter & ServiceRequestTableParams>;

export function matches(a: ServiceRequest, b: ServiceRequest): boolean {
  return match(a, b, props);
}

export const serviceRequestUtils = {
  props,
  paramProps,
  searchProps,
  filterProps,
  matches,
};
